/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for inviting an organization to an event.
 * @export
 * @interface EventOrganizationCreate
 */
export interface EventOrganizationCreate {
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationCreate
     */
    organization_id: string;
}

/**
 * Check if a given object implements the EventOrganizationCreate interface.
 */
export function instanceOfEventOrganizationCreate(value: object): value is EventOrganizationCreate {
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    return true;
}

export function EventOrganizationCreateFromJSON(json: any): EventOrganizationCreate {
    return EventOrganizationCreateFromJSONTyped(json, false);
}

export function EventOrganizationCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventOrganizationCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
    };
}

export function EventOrganizationCreateToJSON(json: any): EventOrganizationCreate {
    return EventOrganizationCreateToJSONTyped(json, false);
}

export function EventOrganizationCreateToJSONTyped(value?: EventOrganizationCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
    };
}

